'use client';
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__ from "@radix-ui/react-select";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__ from "@radix-ui/react-icons";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__ from "@radix-ui/react-label";
const contentCN = `
  ptw-z-top
  ptw-ml-[13px]
  ptw-overflow-hidden
  ptw-rounded
  ptw-bg-surface-base
  ptw-shadow-[0px_10px_38px_-10px_rgba(22,_23,_24,_0.35),0px_10px_20px_-15px_rgba(22,_23,_24,_0.2)]
`;
const labelCN = `
  ptw-absolute
  ptw-left-4
  ptw-top-[calc(50%-0.75rem)]
  ptw-transition-all
  ptw-pointer-events-none
`;
const labelSelectedCN = `
  ptw-absolute
  ptw-p-1
  ptw-top-[-0.625rem]
  ptw-bg-primary-text
  ptw-transition-all
  ptw-text-body-sm
`;
const Select = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ children, label, onValueChange, ...props }, forwardedRef)=>{
    const [internalValue, setInternalValue] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(props.value || void 0);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Root, {
        value: internalValue,
        onValueChange: (v)=>{
            setInternalValue(v);
            if (onValueChange) onValueChange(v);
        },
        ...props,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Trigger, {
                id: `${label}-trigger`,
                className: "ptw-relative ptw-inline-flex ptw-h-[56px] ptw-w-full ptw-items-center ptw-justify-between ptw-rounded ptw-border-medium ptw-border-solid ptw-border-secondary-base ptw-bg-utils-transparent ptw-px-[15px] data-[error=true]:ptw-border-medium data-[error=true]:ptw-border-error-base",
                ref: forwardedRef,
                "data-error": props['data-error'],
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Value, {
                        className: "ptw-peer"
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_label_49d956a0__.Label, {
                        className: internalValue || props.defaultValue ? labelSelectedCN : labelCN,
                        children: label
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Icon, {
                        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__.ChevronDownIcon, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Portal, {
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Content, {
                    className: contentCN,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ScrollUpButton, {
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__.ChevronUpIcon, {})
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Viewport, {
                            className: "ptw-p-[5px]",
                            children: children
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ScrollDownButton, {
                            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__.ChevronDownIcon, {})
                        })
                    ]
                })
            })
        ]
    });
});
const SelectItem = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ children, ...props }, forwardedRef)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.Item, {
        className: "ptw-relative ptw-flex ptw-h-[25px] ptw-select-none ptw-items-center ptw-rounded-[3px] ptw-pl-[25px] ptw-pr-[35px] ptw-leading-none data-[disabled]:ptw-pointer-events-none data-[highlighted]:ptw-bg-primary-base data-[disabled]:ptw-text-disabled-text data-[highlighted]:ptw-text-primary-text data-[highlighted]:ptw-outline-none",
        ...props,
        ref: forwardedRef,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ItemText, {
                children: children
            }),
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_select_36a82244__.ItemIndicator, {
                className: "ptw-absolute ptw-left-0 ptw-inline-flex ptw-w-[25px] ptw-items-center ptw-justify-center",
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_icons_b6b881c0__.CheckIcon, {})
            })
        ]
    }));
Select.displayName = 'Select';
SelectItem.displayName = 'SelectItem';
export { Select, SelectItem };
